import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OkCancelDialog} from '../../../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';
import {useWorkspacesEditor} from '../context/workspacesEditorContext';

/*
 * Component.
 */

export const WorkspacesConflictDialog: FC = () => {
  const {onDismissEditor} = useWorkspacesEditor();

  return (
    <OkCancelDialog
      title={<Trans id="workspaces-conflict-dialog-title">There was a problem</Trans>}
      onOkClick={onDismissEditor}
      isCancelHidden
    >
      <Trans id="workspaces-conflict-dialog-body">
        Unfortunately, we couldn&apos;t save your changes because your sidebar was updated while you were
        editing. You can reopen “Edit sidebar” and try again immediately.
      </Trans>
    </OkCancelDialog>
  );
};
